import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(!user);

  useEffect(() => {
    // If user passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setIsChecking(false);
      return;
    }
    
    if (!user && !loading) {
      checkAuth().finally(() => setIsChecking(false));
    } else {
      setIsChecking(false);
    }
  }, [user, loading, checkAuth, location.state]);

  if (loading || isChecking) {
    return (
      <div className="min-h-screen bg-[#020617] flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Redirect based on role: CRM per admin/operatori, Dashboard per clienti
    if (user.role === 'super_admin' || user.role === 'admin_sede' || user.role === 'operatore') {
      return <Navigate to="/crm" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
